module.exports = __webpack_public_path__ + "img/like.4e702513.svg";